function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "6 10 15 10 19 39 54 39 57 18 21 18 23.3 34"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 31,
  x2: 37,
  y1: 50,
  y2: 50
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 47,
  cy: 50,
  r: 5
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 26,
  cy: 50,
  r: 5
});

function SvgIconfinderSimpline412305621(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfinderSimpline412305621);
export default __webpack_public_path__ + "static/media/iconfinder_simpline_41_2305621.fa3fd694.svg";
export { ForwardRef as ReactComponent };